import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { useSelector, useDispatch } from 'react-redux';
import { Nav, NavDropdown } from 'react-bootstrap';

import s from './NavigationBeforeLogin.css';

import LoginModal from '../LoginModal';
import SignupModal from '../SignupModal';
import ForgotPassword from '../ForgotPassword';
import HeaderModal from '../HeaderModal';
import NavLink from '../NavLink';
import DropDownMenu from '../DropDownMenu/DropDownMenu';

import { openHeaderModal } from '../../actions/modalActions';
import messages from '../../locale/jsonMessages';
import currencyIcon from '/public/SiteIcons/currencyIcon.svg';
import currencyIconTwo from '/public/SiteIcons/currencyIconTwo.svg';

function NavigationBeforeLogin({ openLoginModal, openSignupModal, homeHeaderOnly, becomeHeader }) {
  const dispatch = useDispatch();
  const intl = useIntl();


  const baseCurrency = useSelector(state => state.currency.base);
  const toCurrency = useSelector(state => state.currency.to);
  const currentLocale = useSelector(state => state.intl.locale);
  const layoutType = useSelector(state => state.siteSettings.data.homePageType);

  const displayCurrency = toCurrency || baseCurrency;

  const handleOpenModal = (modalType) => {
    dispatch(openHeaderModal(modalType));
  };
  return (
    <div>
      <LoginModal />
      <SignupModal />
      <ForgotPassword />
      <HeaderModal />

      <Nav pullRight className='normalHeader'>
        {homeHeaderOnly && (
          <div className={cx(s.centerMenu, s.tabViewHidden, 'hidden-xs', 'hidden-md', 'hidden-sm')}>
            <NavLink to="/#" className={cx(s.centerLink, s.dot, 'headerDotRTL', 'dotHeaderRTL', layoutType == 2 ? 'centerLink2' : '', layoutType == 2 ? 'dot2' : '')}>
              <FormattedMessage {...messages.placesToStay} />
            </NavLink>
            <NavLink to="/why-become-owner" className={cx(s.centerLink, 'centerLinkRTL', layoutType == 2 ? 'centerLink2' : '')}>
              <FormattedMessage {...messages.becomeAHost} />
            </NavLink>
          </div>
        )}

        <NavLink to="/" className={cx("hidden-lg", s.newMenuDesign, 'borderNoneMb')}>
          <FormattedMessage {...messages.home} />
        </NavLink>

        {!homeHeaderOnly && !becomeHeader && (
          <NavLink to="/why-become-owner" className={cx('beforeLoginHeaderBecomeAHostLink', s.listCarCss, 'listCarCssRTL')}>
            <FormattedMessage {...messages.listYourCar} />
          </NavLink>
        )}

        <NavLink
          noLink
          onClick={() => handleOpenModal('languageModal')}
          className={cx('hidden-xs', 'hidden-md', s.nonBreakPointScreen)}
        >
          <img src={currencyIconTwo} alt="Currency Icon" />
        </NavLink>

        <NavLink
          noLink
          onClick={() => handleOpenModal('languageModal')}
          className={cx(s.breakPointScreen, "hidden-lg")}
        >
          <FormattedMessage {...messages.languageCurrency} />
        </NavLink>
        {!homeHeaderOnly && !becomeHeader && (
          <NavLink to="/why-become-owner" className={cx(s.breakPointScreen, "hidden-lg")}>
            <FormattedMessage {...messages.listYourCar} />
          </NavLink>
        )}
        <NavLink to="#" noLink onClick={openLoginModal} className={cx(s.breakPointScreen, "hidden-lg")}>
          <FormattedMessage {...messages.login} />
        </NavLink>

        <NavLink to="#" noLink onClick={openSignupModal} className={cx(s.breakPointScreen, "hidden-lg")}>
          <FormattedMessage {...messages.signup} />
        </NavLink>

        <NavLink to="/help" className={cx(s.breakPointScreen, "hidden-lg")}>
          <FormattedMessage {...messages.help} />
        </NavLink>

        <NavDropdown
          className={cx('hidden-xs', s.nonBreakPointScreen)}
          eventKey={3}
          title={<DropDownMenu homeHeaderOnly={homeHeaderOnly} />}
          noCaret
          id="basic-nav-dropdown"
        >
          <NavLink to="#" noLink onClick={openLoginModal}>
            <FormattedMessage {...messages.login} />
          </NavLink>
          <NavLink to="#" noLink onClick={openSignupModal}>
            <FormattedMessage {...messages.signup} />
          </NavLink>
          <NavLink to="/help">
            <FormattedMessage {...messages.help} />
          </NavLink>
        </NavDropdown>
      </Nav>
    </div>
  );
}

NavigationBeforeLogin.propTypes = {
  openLoginModal: PropTypes.func,
  openSignupModal: PropTypes.func,
  homeHeaderOnly: PropTypes.bool,
  becomeHeader: PropTypes.bool,
};

export default withStyles(s)(NavigationBeforeLogin);
